import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Avatar, Grid2 as Grid, Stack } from "@mui/material";
import {
  fetchCoursesByCreator,
  // deleteCourse,
  // fetchCourseResultsByStudent,
  // getCourseInfo,
  // getSortedCoursesList,
  // fetchCourseProgress,
  // updateCurriculum
} from '../../utils/api';
import { USER_TYPE } from '../../config/const';
import SoopraIcon from '../../assets/images/soopra-icon.png';
// import { TierContext } from "../../context/TierContext";
import DefaultUserImage from '../../assets/images/default-avatar.png';
import { UserFormType } from "../creatorOnBoarding/signup.types";

interface UserCourseDataProps {
  authUser?: UserFormType;
  profileData?: UserFormType;
}

// const showMyCourse = process.env.REACT_APP_SHOW_MY_COURSE === 'true';
// const allowSelfPublishedCourses = process.env.REACT_APP_ALLOW_SELF_PUBLISHED_COURSES === 'true';

export const setLoadingState = (
    setFunc: React.Dispatch<React.SetStateAction<{data: any, isLoading: boolean}>>,
    state: boolean
  ) => {
  setFunc((info) => {
    let copy = {...info};
    copy.isLoading = state;
    return copy;
  })
}

const UserCourseData: React.FC<UserCourseDataProps> = (props) => {
  const { authUser, profileData } = props;
  const [courses, setCourses] = useState({data: [], isLoading: false});
  // const [enrolledCourses, setEnrolledCourses] = useState({data: [], isLoading: false});
  // const [filteredEnrolledCourses, setFilteredEnrolledCourses] = useState({data: [], isLoading: false});

  const {
    userId = '',
    // fullName = '',
    // profilePicUrl = '',
    userName = '',
    index = '',
  } = profileData || {};
  const { documentId: authDocumentId = '' } = authUser || {};

  const navigate = useNavigate();
  // const { checkPermission } = useContext(TierContext);

  React.useEffect(() => {
    if (authUser?.userType === USER_TYPE.CREATOR && userId === authDocumentId) {
      loadCourseData()
    }
  }, [userId]); //eslint-disable-line react-hooks/exhaustive-deps

  const loadCourseData = async () => {
    setLoadingState(setCourses, true);
    fetchCoursesByCreator(userId)
        .then(data => {
          data.forEach(course => {
            course.creator_avatar ||= authUser?.profilePicUrl;
            course.creator_name ||= authUser?.fullName;
          })
          setCourses((info) => {
            let copy = {...info};
            copy.data = data;
            return copy;
          });
        })
        .catch(error => {
          console.error('Error fetching courses:', error);
        })
        .finally(() => {
          setLoadingState(setCourses, false)
        })
  }

  // React.useEffect(() => {
  //   if (authUser && documentId === authDocumentId) {
  //     setLoadingState(setEnrolledCourses, true)

  //     fetchCourseResultsByStudent(authUser.uid)
  //       .then(async (results) => {
  //         const enrolledCoursesWithDetails = await Promise.all(results.map(async (course) => {
  //           const courseInfoRes = await getCourseInfo(course.courseId);
  //           const courseInfo = await courseInfoRes.json();
  //           const courseProgressRes = await fetchCourseProgress(`course_${course.courseId}.${authUser.documentId}`);
  //           const courseProgress = courseProgressRes.progress;

  //           return {
  //             ...course,
  //             name: courseInfo.name,
  //             subject: courseInfo.subject,
  //             grade: courseInfo.grade,
  //             creator_name: courseInfo.creator_name,
  //             creatorAvatar: courseInfo.creator_avatar,
  //             module_count: courseInfo.module_count,
  //             course_completed: courseProgress.course_completed,
  //           };
  //         }));
  //         setEnrolledCourses(
  //           {
  //           data: enrolledCoursesWithDetails,
  //           isLoading: true}
  //         );
  //       })
  //       .catch(error => {
  //         console.error('Error fetching enrolled courses:', error);
  //       })
  //       .finally(() => {
  //         setLoadingState(setEnrolledCourses, false)
  //       })
  //   }
  // }, [authUser]); //eslint-disable-line react-hooks/exhaustive-deps

  // React.useEffect(() => {
  //   const fetchFilteredEnrolledCourses = async () => {
  //     if (enrolledCourses.data.length > 0) {
  //       const sortedCoursesResponse = await getSortedCoursesList(1, 100);
  //       const sortedCourses = await sortedCoursesResponse.json();
  //       const filteredCourses = enrolledCourses.data.filter(course =>
  //         sortedCourses.data.some(sortedCourse => sortedCourse.course_id === course.courseId)
  //       );
  //       setFilteredEnrolledCourses({data: filteredCourses, isLoading: false});
  //     }
  //   };

  //   fetchFilteredEnrolledCourses();
  // }, [enrolledCourses]);

  // const handleDeleteCourse = async (courseId) => {
  //   if (window.confirm("Are you sure you want to delete this course?")) {
  //     try {
  //       await deleteCourse(courseId);
  //       setCourses({data: courses.data.filter(course => course.course_id !== courseId), isLoading: false});
  //       alert('Course deleted successfully!');
  //     } catch (error) {
  //       console.error('Error deleting course:', error);
  //       alert('Failed to delete course');
  //     }
  //   }
  // };

  // const shouldPublishCourse = async (course: any, shouldPublish: boolean) => {
  //   if (!checkPermission("publish:ownCourse")){
  //     return;
  //   }
  //   if (window.confirm(`Are you sure you want to ${shouldPublish ? "" : "un"}publish your course on ${course?.name}?`)) {
  //     try {
  //       if (!course?.course_id) throw new Error('Course not found');
  //       if (shouldPublish && !course?.creation_done) throw new Error('Cannot publish incomplete course');
  //       if (!shouldPublish && course?.student_count) throw new Error('Cannot unpublish course with enrolled students');

  //       let updatedCourseInfo = { is_published: shouldPublish };
  //       await updateCurriculum(course.course_id, updatedCourseInfo, true);

  //       setCourses({
  //         data: courses.data.map(tmpCourse => (
  //           tmpCourse.course_id === course.course_id
  //             ? { ...tmpCourse, is_published: shouldPublish }
  //             : tmpCourse
  //         )),
  //         isLoading: false,
  //         }
  //       );
  //       alert(`Course ${shouldPublish ? "" : "un"}published successfully!`);
  //     } catch (error) {
  //       console.error(`Error ${shouldPublish ? "" : "un"}publishing course: `, error);
  //       alert(`Failed to ${shouldPublish ? "" : "un"}publish course`);
  //     }
  //   }
  // };

  const CourseCard = ({ course, isEnrolled }: { course: any; isEnrolled: boolean }) => (
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 3,
      }}
      sx={{ display: 'flex', justifyContent: 'center' }}
    >
      <Box
        component={'a'}
        href={`/courses/${course?.course_id}`}
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          overflow: "hidden",
          backgroundColor: "white",
          width: '100%',
          textDecoration: 'none'
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          navigate(`/courses/${course?.course_id}`)
        }}
      >
        <Avatar
          src={
            course?.banner_image || course?.creator_avatar || SoopraIcon
          }
          alt={course?.name || 'course-banner'}
          sx={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            aspectRatio: '1.78',
            borderRadius: (theme) => theme.shape.borderRadius,
          }}
        />
        <Box p={1.5}>
          <Typography
            component='p'
            variant='body2'
            color='text.secondary'
            align='left'
          >
            {course?.subject}
          </Typography>
          <Typography variant='h7' color='text.primary' align='left' pt={0.5}>
            {course?.name}
          </Typography>
          <Stack direction={'row'} alignItems='center' pt={0.5}>
            <Avatar
              sx={{ width: 24, height: 24 }}
              alt={course?.creator_name}
              src={course?.creator_avatar || DefaultUserImage}
            />
            <Typography
              component='p'
              variant='body3'
              color='text.secondary'
              align='left'
              pl={1}
            >
              {course?.creator_name}
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Grid>
  );


  const CreatedCourses = () =>
    {
      return (courses.data.length || courses.isLoading ) ?
      <Box mt={3} display='flex' flexDirection='column' width='100%' gap={1.5}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography color={'text.secondary'}  variant='body2'>
            {`${authUser?.userName === profileData.userName ? 'My ' : ''}Courses`}
          </Typography>
          <Box display="flex" alignItems="center">
            <Link
              id={index ? `href-create-course-${userName}` : ''}
              to={index ? `/createCourse` : ''}
              aria-disabled={!index}
              style={{
                cursor: index ? 'pointer' : 'not-allowed',
                textDecoration: 'none',
              }}
            >
              <Button
                id="button-create-course"
                variant="contained"
                size="small"
                sx={{
                  py: 1,
                  fontWeight: 400,
                  backgroundColor: 'black',
                  color: 'white',
                  width: '200px',
                  display: { xs: 'none', sm: 'block' }, // Hide on mobile (xs), show on larger screens (sm and up)
                  '&:hover': {
                    backgroundColor: 'black',
                    color: 'white',
                  },
                }}
              >
                Create New Course
              </Button>
            </Link>
          </Box>
        </Box>
        {courses.isLoading ? (
          <Typography>Loading...</Typography>
        ) : courses.data.length > 0 ? (
          <Grid container spacing={3}>
            {courses.data.map((course) => (
              <CourseCard key={course.course_id} course={course} isEnrolled={true} />
            ))}
          </Grid>
        ) : (
          <Typography>No created courses found.</Typography>
        )}
      </Box>
      : <></>
    };

  // const EnrolledCourses = () => {
  //   return (courses.data.length || courses.isLoading ) ?
  //     <Box mt={4} px={0}>
  //       <Typography variant="body1" fontWeight="600" color={'text.secondary'} gutterBottom>
  //         Enrolled Courses
  //       </Typography>
  //       {enrolledCourses.isLoading ? (
  //         <Typography>Loading...</Typography>
  //       ) : filteredEnrolledCourses.data.length > 0 ? (
  //         <Grid2 container spacing={3}>
  //           {filteredEnrolledCourses.data.map((course) => (
  //             <CourseCard key={course.courseId} course={course} isEnrolled={true} />
  //           ))}
  //         </Grid2>
  //       ) : (
  //         <Typography>You have not enrolled in any courses.</Typography>
  //       )}
  //     </Box> : <></>
  // };

  return (
    <>
      <CreatedCourses />
    </>
  );
};

export default UserCourseData;
